import { type AppState, type RedirectLoginOptions } from '@auth0/auth0-react'

import { AUTH0_SCOPE, callbackUri } from '../auth.config'

export function loginWithRedirectParams(): RedirectLoginOptions<AppState> {
  const appname = String(process.env['PROJECT'] ?? '').toLowerCase()
  const defaultOptions = {
    authorizationParams: {
      redirectUri: callbackUri,
      scope: AUTH0_SCOPE,
    },
  }

  if (!appname) {
    return defaultOptions
  }
  if (appname === 'saas') {
    return {
      ...defaultOptions,
      authorizationParams: {
        ...defaultOptions.authorizationParams,
        // @todo: Change during onboarding feature
        // Register as SaaS Subscriber
        // https://github.com/flecto-io/backend/issues/320
        // scope: 'openid profile email signup_origin:saas'
        scope: 'openid profile email',
      },
    }
  }

  return {
    authorizationParams: {
      redirect_uri: callbackUri,
      scope: AUTH0_SCOPE,
    },
  }
}
